import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common/constants';

const states: Ng1StateDeclaration[] = [
    {
        name: 'approval',
        url: '/approval/:groupGuid?/:beginDate?/:approvalStrategyGuid?',
        template: '<wt-approval-state class="flex-directive"></wt-approval-state>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([Roles.master, Roles.engineer, Roles.operator])
        },
        params: {
            groupGuid: '',
            beginDate: '',
            approvalStrategyGuid: ''
        },
        data: {
            icon: 'fa-thumbs-o-up',
            displayName: 'Approval',
            editRoles: [Roles.engineer],
            editButtonVisibility: () => false
        }
    }];

export default states;